/* Do not edit! The file is automatically copied from the shared folder */

import type { BaseTranslation } from '../i18n-types';

export const shared = {
    key: 'Some text',
} satisfies BaseTranslation;
